import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import TheSrdStandard from "./sections/TheSrdStandard";
import StrategicPillars from "./sections/StrategicPillars";
import ServicesInformation from "./sections/ServicesInformation";
import Products from "./sections/Products";
import AccreditationsPartners from "./sections/AccreditationsPartners";
import WordsFromTheRoad from "./sections/WordsFromTheRoad";
import InitializeYourMission from "./sections/InitializeYourMission";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <TheSrdStandard />
      <StrategicPillars />
      <ServicesInformation />
      <Products />
      <AccreditationsPartners />
      <WordsFromTheRoad />
      <InitializeYourMission />
      <Footer />
    </div>;
}